import { render, staticRenderFns } from "./I2FormInput.vue?vue&type=template&id=4e34fb36&scoped=true"
import script from "./I2FormInput.vue?vue&type=script&lang=js"
export * from "./I2FormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e34fb36",
  null
  
)

export default component.exports